import { render } from "./HomeView.vue?vue&type=template&id=0b912b66&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=0b912b66&lang=scss&scoped=true"

import exportComponent from "C:\\PROJEKTE\\GAMES\\dead-technologies\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b912b66"]])

export default __exports__